import { isAddressEqual } from 'viem';
export class OneInchCrossChainSDK {
    constructor(appContext) {
        this.appContext = appContext;
    }
    async getInstance() {
        if (!OneInchCrossChainSDK.instance) {
            OneInchCrossChainSDK.instance = await buildFusionPlusSDK(this.appContext.isEmbedded ? '/' : '/proxy/direct/fusion-plus', this.appContext.wallet, this.appContext.api.getProxyClient());
        }
        return OneInchCrossChainSDK.instance;
    }
}
async function buildFusionPlusSDK(host, walletController, proxyClient) {
    const { SDK } = await import('@1inch/cross-chain-sdk');
    return new SDK({
        url: host,
        httpProvider: proxyClient,
        blockchainProvider: {
            signTypedData: async (walletAddress, typedData) => {
                const activeWalletAddress = await walletController.data.getActiveAddress();
                if (!activeWalletAddress || !isAddressEqual(activeWalletAddress, walletAddress)) {
                    throw new Error('');
                }
                return await walletController.signTypedData(typedData);
            },
            ethCall: async () => {
                return '';
            },
        },
    });
}
//# sourceMappingURL=1inch-cross-chain-sdk.js.map